<template>
  <GenericDrawer
    colorKey="bgAppBar"
    :isOpen="isOpen"
    :isSubDrawer="true"
    :topLinks="topLinks"
    :bottomLinks="bottomLinks"
    @toggle="$emit('toggle', $event)"
  >
    <template v-slot:prepend>
      <v-container> </v-container>
    </template>
  </GenericDrawer>
</template>

<script>
import { PROJECT_DRAWER_BOTTOM, PROJECT_DRAWER_TOP, CLIENT_DRAWER_TOP } from "@/utils/links";

export default {
  name: "ProjectDrawer",
  components: {
    GenericDrawer: () => import("@/components/layouts/core/GenericDrawer.vue"),
  },
  props: {
    isOpen: { type: Boolean, default: true },
    isMobile: { type: Boolean, default: false },
  },
  data: () => ({
    // topLinks: PROJECT_DRAWER_TOP,
    bottomLinks: PROJECT_DRAWER_BOTTOM,
  }),
  computed: {
    showClient() {
      return this.$store.getters["app/getCompany"].company_type;
    },
    topLinks() {
      return this.showClient === 'Partners' ? CLIENT_DRAWER_TOP : PROJECT_DRAWER_TOP
    },
  },
  created() {
    // Charge les privileges utilisateur pour que le filtrage des menus
    // (userHasMenu) puisse s'appliquer correctement au rendu du drawer.
    if (this.$store.state.app.userPrivileges === null) {
      this.$store.dispatch("app/loadUserPrivileges")
    }
  },
};
</script>
